import { Swiper, SwiperSlide } from "swiper/react";
import { Link } from "react-router-dom";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "./Hero.css";

function Hero() {
  return (
    <section className="hero-section">
      <Swiper
        modules={[ Pagination, Autoplay]}
        navigation
        pagination={{ clickable: true }}
        autoplay={{ delay: 4000, disableOnInteraction: false }}
        loop={true}
        className="hero-swiper"
      >
        {/* Slide 1 */}
        <SwiperSlide>
          <div className="hero-slide slide-1 d-flex flex-column flex-sm-row align-items-sm-center">
            {/* Text Content */}
            <div className="hero-content text-start">
              <h1 className="hero-title">Wireless Headset</h1>
              <p className="hero-desc">
                100% trusted Electronics gadgets.
              </p>

              <Link to="/products" className="btn btn-outline-warning hero-btn mt-3">
  Shop Now
</Link>
            </div>
          </div>
        </SwiperSlide>

        {/* Slide 2 */}
        <SwiperSlide>
          <div className="hero-slide slide-2 d-flex flex-column flex-sm-row align-items-sm-center">
            <div className="hero-content text-start">
            <h1 className="hero-title">DSLR 360 Camera</h1>
              <p className="hero-desc">
                100% trusted Electronics gadgets.
              </p>
              <button className="btn btn-outline-warning hero-btn mt-3">
                Shop Now
              </button>
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="hero-slide slide-3 d-flex flex-column flex-sm-row align-items-sm-center">
            <div className="hero-content text-start">
            <h1 className="hero-title">Wireless Earbuds</h1>
              <p className="hero-desc">
                100% trusted Electronics gadgets.
              </p>
              <button className="btn btn-outline-warning hero-btn mt-3">
                Shop Now
              </button>
            </div>
          </div>
        </SwiperSlide>
      </Swiper>
    </section>
  );
}

export default Hero;
